export default __webpack_public_path__ + "static/media/gmail.86a3bb9b.svg";